import { apiClient } from './apiClient';

const base = '/api/config';

export const configService = {
  get: () => apiClient.get(base),
  update: payload => apiClient.put(base, payload),
};

export default configService;
